import React from "react"
import styled, { keyframes } from "styled-components"
import { CardDataStructure } from "../../data/CardData"

export default function CardHero() {
  return (
    <>
      <Wrapper>
        {CardDataStructure.map(item => {
          return (
            <>
              <WrapperContent>
                <WrapperCard>
                  <WrapperBanner>
                    <div
                      style={{
                        transition:
                          "all 0.8s cubic-bezier(0.075, 0.82, 0.165, 1) 0s",
                      }}
                    >
                      <WrapperImage src={item.image} />
                    </div>
                  </WrapperBanner>
                  <WrapperDescription>
                    <WrapperParagraph>{item.title}</WrapperParagraph>
                    <WrapperSubtitle>{item.subtitle}</WrapperSubtitle>
                  </WrapperDescription>
                </WrapperCard>
              </WrapperContent>{" "}
            </>
          )
        })}
      </Wrapper>
    </>
  )
}

const load = keyframes`
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
`

const Wrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, 218px);
  justify-items: center;
  gap: 20px;
  max-width: 1234px;
  margin: 40px auto;
  padding: 40px 0px 40px 0px;
  position: relative;
  top: -40px;
  pointer-events: visible;

  @media (max-width: 1234px) {
    top: -180px;
    grid-template-columns: repeat(5, minmax(200px, 1fr));
    padding-bottom: 120px;
    overflow-x: scroll;
  }
`

const WrapperContent = styled.div`
  transition: all 0.8s cubic-bezier(0.075, 0.82, 0.165, 1) 0s;
  cursor: pointer;
  transition-delay: 100ms;

  :hover {
    transform: scale(1.1);
  }
`

const WrapperCard = styled.div`
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 1fr 1fr;
  min-width: 200px;
  height: 360px;
  border-radius: 20px;
  background: linear-gradient(
    209.21deg,
    rgb(46, 20, 103) 13.57%,
    rgb(60, 161, 254) 98.38%
  );
  box-shadow: rgba(60, 161, 254, 0.3) 0px 20px 40px,
    rgba(0, 0, 0, 0.05) 0px 1px 3px;
  padding: 20px;

  @media screen and (-webkit-min-device-pixel-ratio: 0) and (min-resolution: 0.001dpcm) {
    box-shadow: none;
  }
`

const WrapperBanner = styled.div`
  position: relative;
  display: grid;
  justify-content: center;
  justify-items: center;
  height: 150px;
`

const WrapperImage = styled.img`
  height: 150px;
  margin: 0px;
  opacity: 0;
  max-width: 100%;
  animation: 1s ease 0s 1 normal forwards running ${load};
`

const WrapperDescription = styled.div`
  position: relative;
  padding-top: 20px;
  transition: all 0.8s cubic-bezier(0.075, 0.82, 0.165, 1) 0s;
`

const WrapperParagraph = styled.p`
  font-style: normal;
  font-size: 24px;
  line-height: 140%;
  font-weight: bold;
  text-align: center;
  color: rgb(255, 255, 255);
  margin: 0px;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`

const WrapperSubtitle = styled.p`
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 18px;
  text-align: center;
  color: rgba(255, 255, 255, 0.7);
  margin: 10px 0px 0px;
`
